// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { loadProductRequiredParameters } from "@store/Framework/Common/Utilities/loadProductHelper";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...loadProductRequiredParameters,
    };
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);
